import { styled, Theme } from '@mui/material/styles';
import Card from '@mui/material/Card';
import { FC, ReactNode } from 'react';
import { useTheme } from '@mui/material';
import { TCustomTheme } from '@mgm/common/theme';
import { useCustomTheme } from '@mgm/common/hooks/useCustomTheme';

type TStyledTotalCard = {
  theme?: Theme,
  color?: string,
  background: string
  padding?: number
};

type TTotalCard = Omit<TStyledTotalCard, 'theme'> & {
  children: ReactNode,
};

const StyledTotalCard = styled(Card)<TStyledTotalCard>(({
  theme, color, background, padding = 2,
}) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme?.spacing(padding),
  color,
  backgroundColor: background,
  [theme.breakpoints.only('xs')]: {
    textAlign: 'right',
  },
}));

const TotalCard: FC<TTotalCard> = ({
  children,
  background,
  color,
  padding,
}) => {
  const theme = useTheme() as TCustomTheme;
  const { isMobile } = useCustomTheme(theme);

  return (
    <StyledTotalCard padding={isMobile ? 2 : padding} background={background} color={color}>
      {children}
    </StyledTotalCard>
  );
};

export {
  TotalCard,
};
